import CarrierRecordBillingView from './CarrierRecordBillingView';

export default CarrierRecordBillingView;
